function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgGps = function SvgGps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477.112 477.112",
    style: {
      enableBackground: "new 0 0 477.112 477.112"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C84E8"
    },
    d: "M238.556,8c-88.366,0-160,71.634-160,160c0,88.368,160,296,160,296s160-207.632,160-296 C398.556,79.634,326.922,8,238.556,8z M238.556,216c-26.51,0-48-21.49-48-48s21.49-48,48-48s48,21.49,48,48S265.066,216,238.556,216 z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A1A7EF"
    },
    cx: 238.556,
    cy: 168,
    r: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M238.556,477.112l-6.336-8.232C225.62,460.32,70.556,258.056,70.556,168 c0-92.784,75.216-168,168-168s168,75.216,168,168c0,90.056-155.064,292.32-161.664,300.88L238.556,477.112z M238.556,16 c-83.909,0.093-151.907,68.091-152,152c0,74.832,122.472,243.2,152,282.728c29.528-39.528,152-207.912,152-282.728 C390.463,84.091,322.465,16.093,238.556,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M238.556,224c-30.928,0-56-25.072-56-56s25.072-56,56-56s56,25.072,56,56 C294.521,198.913,269.469,223.965,238.556,224z M238.556,128c-22.091,0-40,17.909-40,40s17.909,40,40,40s40-17.909,40-40 C278.53,145.92,260.636,128.026,238.556,128z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gps.b7bf2ac6.svg";
export { ForwardRef as ReactComponent };